import * as React from "react"

import Spinner from "./spinner.js"

const Loader = props => {
  return <Spinner {...props} />
}

export default Loader
